/**
 * Footer 组件
 * 
 * 功能：
 * 1. 显示版权信息
 * 2. 显示 ICP 备案号
 * 3. 显示公安备案号和图标
 */
export function Footer() {
  return (
    <footer className="border-t border-default-200 bg-content1/90 py-6 backdrop-blur-sm">
      <div className="container mx-auto px-4">
        <div className="text-center text-sm text-default-600">
          <p>
            © 2025-2026 人文派
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-1 text-primary transition-colors hover:text-primary-600"
            >
              鲁ICP备2024136004号-1
            </a>
          </p>
          <p className="mt-2 flex items-center justify-center gap-2">
            <img
              src="https://www.beian.gov.cn/img/new/gongan.png"
              alt="公安备案图标"
              className="h-4 w-4 inline-block"
            />
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=37011202002338"
              rel="noreferrer"
              target="_blank"
              className="text-primary transition-colors hover:text-primary-600"
            >
              鲁公网安备37011202002338号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

